
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SeAvatarModule, SE_AVATAR_MODULE_BUNDLE } from '../avatar/avatar.module'
import { SeIconModule, SE_ICON_MODULE_BUNDLE } from '../icon/icon.module'

import { SeOrgAvatarComponent } from './org-avatar.component'

@NgModule({
  declarations: [
    SeOrgAvatarComponent,
  ],
  imports: [
	CommonModule, 
    SeAvatarModule,
    SeIconModule
  ],
  exports: [
    SeOrgAvatarComponent,
  ]
})
export class SeOrgAvatarModule {}

export const SE_ORG_AVATAR_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.orgAvatar`

